<template>
<div class="container-fluid">
    <div class="not_ib">
    <div class="text-center">
        <img src="../../assets/image/pending_ib.svg" alt="" class="pending_ib mb-4 mw-100">
        <h3 class="title">Waiting for approval</h3>
        <p class="desc">Thank you for applying as an agent. Please wait for verification from the admin regarding the status of your registration.</p>
        <div class="option_btn">
        <router-link to="/" class="btn btn_outline_grey">Go To Dashboard</router-link>
        </div>
    </div>
    </div>
</div>
</template>
<script>
export default {
  name: "DashboardPendingIb",
  components: {},
  props: {
    loading : Boolean
  }
}
</script>
